import Script from 'next/script'

/**
 * Podscribe Pixel Integration
 *
 * This script handles the Podscribe conversion tracking pixel.
 * The pixel only fires after the user has approved marketing tracking in OneTrust.
 *
 * Pixel ID: 30a6f746-1c4d-44d2-8996-3528316e9313
 */

const PODSCRIBEPIXEL_ID = '30a6f746-1c4d-44d2-8996-3528316e9313'

const podScribePixelScript = `
(function (w, d) {
  var id = 'podscribe-capture',
    n = 'script';
  var e = d.createElement(n);
  e.id = id;
  e.async = true;
  e.src = 'https://d34r8q7sht0t9k.cloudfront.net/tag.js';
  var s = d.getElementsByTagName(n)[0];
  s.parentNode.insertBefore(e, s);
  e.addEventListener('load', function() {
    w.podscribe('init', { user_id: '${PODSCRIBEPIXEL_ID}', advertiser: 'interflora' });
    w.podscribe('view');
  });
})(window, document);
`

/**
 * Render Podscribe Pixel
 * This should be called in the Page component after OneTrust initialization
 */

export function renderPodScribePixel() {
  return (
    <Script
      id="podscribe-capture"
      strategy="afterInteractive"
      type="text/plain"
      className="optanon-category-C0004"
      dangerouslySetInnerHTML={{
        __html: podScribePixelScript,
      }}
    />
  )
}
